import { useCallback, useContext } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';

const useMarkReportAsFilteredByEntity = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);

  const markReportAsFilteredByEntity = useCallback(
    (report: ReportType) => {
      const newReport: ReportType = {
        ...report,
        isEntityFilterEnabled: true,
      };

      return STORE.getReportsRef({ accountId: selectedAccountId })
        .doc(newReport.id)
        .set(newReport);
    },
    [selectedAccountId],
  );

  return markReportAsFilteredByEntity;
};

export default useMarkReportAsFilteredByEntity;
